const initialState = {
    sessionId: "",
    questionScore: [],
  };
  
  const questionReducer = (state = initialState, action) => {
    if (action.type === "QUESTION_SCORE") {
      return action.questionConfig;
    }
  
    if (action.type === "QUESTION_LOGOUT") {
      return initialState;
    }
    
    return state;
  };
  
  export default questionReducer;
  